/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '~/lib/api/axiosClient';
import type {
  CriarCompromissoAvulsoMutationRequest,
  CriarCompromissoAvulsoMutationResponse,
  CriarCompromissoAvulso401,
} from '../../types/CriarCompromissoAvulso.ts';
import type { RequestConfig, ResponseErrorConfig } from '~/lib/api/axiosClient';

function getCriarCompromissoAvulsoUrl() {
  const res = {
    method: 'POST',
    url: `/compromisso-avulso/criar-compromisso-avulso` as const,
  };
  return res;
}

/**
 * @description Cria compromissos avulsos para pastas ou compromissos existentes
 * @summary Criar compromisso avulso
 * {@link /compromisso-avulso/criar-compromisso-avulso}
 */
export async function criarCompromissoAvulso(
  data?: CriarCompromissoAvulsoMutationRequest,
  config: Partial<RequestConfig<CriarCompromissoAvulsoMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    CriarCompromissoAvulsoMutationResponse,
    ResponseErrorConfig<CriarCompromissoAvulso401>,
    CriarCompromissoAvulsoMutationRequest
  >({
    method: 'POST',
    url: getCriarCompromissoAvulsoUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
